const randomKey = () => Math.random().toString(36).substring(2, 7);

export default {
    state: () => {
        return {
            subscriptions: {
                termTemplateUpdated: {
                    componentKey: randomKey(),
                },

                termUpdated: {
                    componentKey: randomKey(),
                },

                termPeriodUpdated: {
                    componentKey: randomKey(),
                    termPeriodId: null,
                },

                termPeriodCourseUpdated: {
                    componentKey: randomKey(),
                    termPeriodCourseId: null,
                },
            },
        };
    },

    getters: {
        termTemplateUpdatedKey(state) {
            return state.subscriptions.termTemplateUpdated.componentKey;
        },

        termUpdatedKey(state) {
            return state.subscriptions.termUpdated.componentKey;
        },

        termPeriodUpdatedKey(state) {
            return state.subscriptions.termPeriodUpdated.componentKey;
        },

        termPeriodUpdatedItem(state) {
            return state.subscriptions.termPeriodUpdated.termPeriodId;
        },

        termPeriodCourseUpdatedKey(state) {
            return state.subscriptions.termPeriodCourseUpdated.componentKey;
        },
    },

    actions: {
        updateSubscription({ commit }, payload) {
            commit(payload.subscription, payload.data);
        },
    },

    mutations: {
        UPDATE_COMPONENT_KEY(state, payload) {
            if (payload.termPeriodId !== undefined) {
                state.subscriptions[payload.action].termPeriodId = payload.termPeriodId;
            }

            if (payload.termPeriodCourseId !== undefined) {
                state.subscriptions[payload.action].termPeriodCourseId = payload.termPeriodCourseId;
            }

            state.subscriptions[payload.action].componentKey = randomKey();
        },
    },
};
